import { Component, Vue } from 'vue-property-decorator';
import ParticipantService from '@/services/participant.service';
import { ParticipantDTO } from '@/models/ParticipantDTO';
import ParticipantAdministrative from '@/components/ParticipantAdministrative/ParticipantAdministrative';
import RenounceButton from '@/components/RenounceButton/RenounceButton';
import ApiError from '@/exceptions/api.error';
import { McsisRole } from '@/models/constants/McsisRole';
import ParticipantContact from '@/components/ParticipantContact/ParticipantContact';
import { IdentificationDTO } from '@/models/IdentificationDTO';
import { store } from '@/store/store';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import InformationBlock from '@/components/InformationBlock/InformationBlock';
import { InclusionTypes } from '@/models/VariousEnum';
import { getCorrespondenceLanguagesBySu } from '@/config/app.config';

@Component({
  components: {
    ParticipantAdministrative,
    RenounceButton,
    ParticipantContact,
    SectionTitle,
    InformationBlock,
  },
})
export default class Inclusion extends Vue {
  public partId: number | undefined;
  public participant: ParticipantDTO = {} as ParticipantDTO;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;
  public rolePharmacist: string = McsisRole[McsisRole.Pharmacist];
  public roleParticipant: string = McsisRole[McsisRole.Participant];
  public identificationData: IdentificationDTO = {} as IdentificationDTO;

  protected get isIdentified(): boolean {
    return store.state.isIdentified;
  }
  protected get isAuthenticated(): boolean {
    return store.state.isAuthenticated;
  }

  protected get isColoInclusion(): boolean {
    return store.state.isColonoscopyMode && store.state.inclusionType === InclusionTypes.colo;
  }

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    ParticipantService.fetchParticipant(this.partId)
      .then((response) => {
        this.participant = response as ParticipantDTO;
      })
      .catch((error: ApiError) => {
        this.error = true;
        switch (error.status) {
          case (500):
            this.errorMessage = this.$i18n.t('errorMgs.serverError').toString();
            break;
          case (401):
            this.errorMessage = this.$i18n.t('errorMgs.sessionExpiration').toString();
            break;
          case (404):
            this.errorMessage = this.$i18n.t('errorMgs.participantNotFound').toString();
            break;
          default:
            this.errorMessage = error.message;
        }
      });

    // Do not fetch the identification data when visiting the first time the inclusion page (as there is no data yet)
    if (store.state.maxVisitedStepNumber > 1) {
      ParticipantService.fetchIdentificationData(this.partId)
        .then((response) => {
          this.identificationData = response as IdentificationDTO;
        });
    }
  }

  protected onSubmit() {
    const correspondenceLanguages = getCorrespondenceLanguagesBySu(this.$route.params.screening);
    if (this.identificationData.correspondenceLang === '' && correspondenceLanguages.length === 1) {
      this.identificationData.correspondenceLang = correspondenceLanguages[0].toString();
    }
    ParticipantService.updateIdentificationInfos(Number(this.partId), this.identificationData)
    .then(() => {
        this.$router.push({
          name: 'questionnary',
          params: {
            screening: this.$route.params.screening,
            partId: String(this.partId),
          },
        });
    });
  }
}

